import { useCallback } from "react";

import { useMutation, UseMutationResult } from "@tanstack/react-query";

import axios from "@/configs/axios";

interface UploadFileResult {
  data: any;
  status: number;
}

export const usePostUploadFileOld = (): UseMutationResult<
  UploadFileResult,
  Error,
  FormData,
  unknown
> => {
  const callUploadFile = useCallback(async (request: FormData): Promise<UploadFileResult> => {
    const url = `${process.env.REACT_APP_SERVER_HOST}/upload`;
    const response = await axios.post(url, request, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Cache-Control": "no-store",
      },
    });
    return response;
  }, []);

  return useMutation<UploadFileResult, Error, FormData, unknown>({
    mutationFn: callUploadFile,
  });
};
